import { useState, useEffect } from 'react';
import { SocialMediaLoginProps } from './useSocialSignIn.types';
import { useFacebook } from './type/useFacebook';
import { useGoogle } from './type/useGoogle';
import { useUser } from 'shared/hooks/useUser';

export const useSocialSignIn = ({
    type,
    actionAfterAuth
}: SocialMediaLoginProps): [string, () => void] => {
    const [socialMediaError, setSocialMediaError] = useState('');
    const currentUser = useUser();
    const socialMediaAction = {
        onSuccess: actionAfterAuth?.action,
        onError: setSocialMediaError,
        eventLabel: actionAfterAuth?.eventLabel,
        segment: actionAfterAuth?.segment
    };

    const socialMediaMap = {
        facebook: useFacebook(socialMediaAction, currentUser),
        google: useGoogle(socialMediaAction, currentUser)
    };

    useEffect(() => {
        initSocialMedia();
    }, []);

    const initSocialMedia = () => {
        socialMediaMap[type]?.init();
    };

    const onSocialMediaSignIn = () => {
        if (!window) {
            return;
        }
        setSocialMediaError('');
        socialMediaMap[type]?.onLogin();
    };

    return [socialMediaError, onSocialMediaSignIn];
};
